'use client';

import clsx from 'clsx';
import { LuMessagesSquare } from 'react-icons/lu';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';
import { TableButton } from '../TableButton/TableButton';
/**
 * Outlined status pill used by grid cells (AI interview, AI phone screening).
 * Composes icon / tick / label / count badge / score badge inside a TableButton,
 * wrapped in CustomTooltip.
 */
export const GridStatusPill = ({
  icon,
  tick,
  label,
  count,
  score,
  tooltip,
  color,
  onClick,
  disabled,
  className,
  'data-testid': testId
}) => <CustomTooltip title={tooltip ?? undefined} placement="top" arrow>
        <TableButton variant="outlined" size="md" onClick={onClick} disabled={disabled} data-testid={testId} className={clsx('gap-1', !color && 'border-brand/75!', className)} style={color ? {
    color,
    borderColor: 'currentColor'
  } : undefined}>
            {icon}
            {tick}
            {label && <span className="text-xs! font-normal!">{label}</span>}

            {Boolean(count && count > 1) && <>
                    <span className="text-xs! font-normal! -mt-0.5!">&middot;</span>
                    <span className={clsx('text-[11px]! leading-none inline-flex items-center gap-0.5 -mb-px! -mr-px!', !color && 'text-brand')} style={color ? {
        color
      } : undefined}>
                        <LuMessagesSquare className="text-[9px]" /> {count}
                    </span>
                </>}

            {score !== null && score !== undefined && <span className={clsx('text-xs font-medium! tracking-wider text-[10px] text-center min-w-6 max-w-8 px-1 py-1 -mr-1 rounded-full text-white', !color && 'bg-brand/70')} style={color ? {
      backgroundColor: `color-mix(in srgb, ${color} 70%, transparent)`
    } : undefined}>
                    {score}
                </span>}
        </TableButton>
    </CustomTooltip>;